module.exports = __webpack_public_path__ + "img/fi.b1f4db0a.jpg";